import { render, staticRenderFns } from "./BuyLead.vue?vue&type=template&id=37b09b59&scoped=true&"
import script from "./BuyLead.vue?vue&type=script&lang=js&"
export * from "./BuyLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b09b59",
  null
  
)

export default component.exports